import React from "react";

import Button from "components/botanic/Button";

import { AgeGateFormProps } from "./AgeGate";

const UsAgeGateForm: React.FC<AgeGateFormProps> = ({ confirm, decline }) => (
  <div>
    <div className="my-lg font-bold text-sm">Are you 21 or older?</div>
    <div className="lg:flex flex-row gap-1.5 flex-none">
      <div className="flex-1 lg:mr-md my-lg lg:my-none">
        <Button
          variant="tertiary"
          onClick={decline}
          className="text-sm"
          style={{
            margin: "-2px", // to prevent border issue
          }}
        >
          not yet
        </Button>
      </div>
      <div className="flex-1 lg:ml-md">
        <Button
          variant="primary"
          onClick={confirm}
          className="text-sm"
          data-testid="age-gate-yes-button"
        >
          you bet!
        </Button>
      </div>
    </div>
  </div>
);

export default UsAgeGateForm;
